import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { MiddlewareAdapterService } from './adapter-service';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { CheckRouteRequestModel } from './models';

/**Сервис для отправки запросов */
const adapterService = new MiddlewareAdapterService();

/**Выброс пользователя из маршрута */
const ejectUser = (next: NavigationGuardNext) => {
  next({ name: 'projects-list' });
};

/**Является ли пользователь админом проекта */
export const checkProjectAdmin = async (
  route: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  //Проверка id проекта
  const projectId = Number(route.params.projectId);
  if (!projectId) {
    ejectUser(next);
    return false;
  }

  if (CurrentUser.Roles.includes(UserRoleEnum.Owner)) return true;

  //Проверка наличия доступа к проекту
  const accessResponse = await adapterService.CheckProjectAdmin(projectId);
  if (!accessResponse.Value) {
    ejectUser(next);
    return false;
  }

  return true;
};

/**Является ли пользователь админом проекта или области */
export const checkNamespaceAdmin = async (
  route: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  //Проверка id проекта
  const projectId = Number(route.params.projectId);
  if (!projectId) {
    ejectUser(next);
    return false;
  }

  if (CurrentUser.Roles.includes(UserRoleEnum.Owner)) return true;

  //Проверка админа проекта
  if (await checkProjectAdmin(route, next)) {
    return true;
  }

  //Проверка наличия id области
  const namespaceId = String(route.params.namespaceId);
  if (!projectId) {
    ejectUser(next);
    return false;
  }

  //Проверка наличия доступа к области
  const accessResponse = await adapterService.CheckNamespaceAdmin(namespaceId);
  if (!accessResponse.Value) {
    ejectUser(next);
    return false;
  }

  return true;
};

/**Является ли пользователь админом проекта */
export const checkTeam = async (route: RouteLocationNormalized, next: NavigationGuardNext) => {
  if (CurrentUser.Roles.includes(UserRoleEnum.Owner)) return true;

  const teamResponse = await adapterService.GetCountEmployeesUser();

  if (!teamResponse.Value) {
    ejectUser(next);
    return false;
  }

  return true;
};

/**Проверка наличия доступа к рабочей области */
export const checkNamespaceAccess = async (
  route: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  console.log('demo');
  return true;
};

/**Проверка роута */
export const checkRoute = async (route: RouteLocationNormalized, next: NavigationGuardNext) => {
  const result = await adapterService.checkRouteAsync(
    new CheckRouteRequestModel({
      ProjectId: Number(route.params.projectId),
      ...(route.params.namespaceId && { NamespaceId: String(route.params.namespaceId) }),
      ...(route.params.queueId && { QueueTaskId: String(route.params.queueId) }),
      ...(route.params.taskId && { TaskId: Number(route.params.taskId) }),
      ...(route.params.groupId && { GroupId: Number(route.params.groupId) }),
    }),
  );

  if (!result.Value) {
    next({
      name: 'project-stub-page',
      params: { projectId: route.params.projectId },
      query: { errorCode: 1111 },
    });
  } else {
    next();
  }
};
